export const de = {
    translation: {
        errorCodes: {
            noTenantAccess: 'Kein Zugriff auf den Mandanten',
        },
        navigation: {
            start: 'Meine Mandanten',
            myProfile: 'Mein Konto',
            tenant: {
                home: 'Startseite',
                users: 'Administratoren',
                authenticationHeader: 'Authentifizierung',
                settings: 'Mandant',
                authProviders: 'Anmeldemethoden',
                applications: 'Anwendungen',
                identities: 'Identitäten',
                apis: 'APIs',
                otherHeader: 'Sonstiges',
                developer: 'API & Entwicklung',
            },
        },
        home: {
            welcome: 'Willkommen',
            intro: 'Schön, dass Sie da sind!',
            newTenantDialog: {
                title: 'Neuer Mandant',
                name: 'Mandantenname',
                language: 'Standardsprache',
                country: 'Standardland',
                createTenant: 'Mandant erstellen',
            },
            tenants: 'Ihre Mandanten',
            newTenant: 'Neuen Mandanten anlegen',
        },
        tenant: {
            home: {
                title: 'Übersicht',
                statistics: {
                    identities: 'Identitäten',
                    applications: 'Anwendungen',
                    recentRegistrations: 'Neue Registrierungen',
                    recentlyActive: 'Zuletzt aktiv',
                    lastSevenDays: 'Letzte 7 Tage',
                },
                info: { title: 'Verbindungsdetails', tenantId: 'Mandanten-ID', issuerUrl: 'Issuer-URL' },
            },
            error: {
                unknown: 'Unbekannter Fehler',
                'missing.tenant': 'Der Mandant konnte nicht geladen werden. Möglicherweise haben Sie keinen Zugriff.',
            },
            applications: {
                title: 'Anwendungen',
                list: {
                    title: 'Anwendungen',
                    sidebar: {
                        title: 'Anwendungen',
                    },
                    toolbar: {
                        title: 'Anwendungen',
                        counter_zero: 'Keine Anwendungen',
                        counter_one: '{{count, number}} Anwendung',
                        counter_other: '{{count, number}} Anwendungen',
                        search: 'Name, Beschreibung',
                        newApplication: 'Anwendung anlegen',
                    },
                    empty: {
                        title: 'Keine Anwendungen',
                        subtitle: 'Legen Sie eine neue Anwendung an, um zu starten',
                        actionCreate: 'Anwendung anlegen',
                    },
                    table: {
                        clientId: 'Client-ID',
                        systemBadge: 'System',
                        typeValues: {
                            native: 'Native',
                            machine: 'Maschine-zu-Maschine',
                            web: 'Klassische Webanwendung',
                            spa: 'Single-Page-Anwendung',
                        },
                    },
                    newApplication: {
                        title: 'Anwendung anlegen',
                        name: 'Name',
                        description: 'Beschreibung',
                        thirdParty: 'Drittanbieter',
                        type: 'Typ',
                        typeValues: {
                            native: {
                                label: 'Native',
                                info: 'Mobile, Desktop-, CLI- und Smart-Device-Apps, die nativ ausgeführt werden.',
                            },
                            machine: {
                                label: 'Maschine-zu-Maschine',
                                info: 'CLIs, Daemons oder Dienste auf Ihrem Backend.',
                            },
                            web: {
                                label: 'Klassische Webanwendung',
                                info: 'Klassische Web-App mit Redirects.',
                            },
                            spa: {
                                label: 'Single-Page-Anwendung',
                                info: 'Moderne Web-App mit Routing im Browser und APIs.',
                            },
                        },
                    },
                },
                application: {
                    error: {
                        invalidUrl: 'Ungültige URL',
                    },
                    header: {
                        general: 'Allgemein',
                        authentication: 'Authentifizierung',
                        apis: 'APIs',
                        experience: 'Erlebnis',
                        appearance: 'Darstellung',
                        security: 'Sicherheit',
                        clientId: 'Client-ID',
                        systemBadge: 'System',
                        typeValues: {
                            native: 'Native',
                            machine: 'Maschine-zu-Maschine',
                            web: 'Klassische Webanwendung',
                            spa: 'Single-Page-Anwendung',
                        },
                    },
                    general: {
                        basicInfo: {
                            title: 'Grundlegende Informationen',
                            subtitle:
                                'Legen Sie fest, wie Ihre Anwendung Nutzern angezeigt wird, einschließlich Name und Beschreibung',
                            name: 'Name',
                            description: 'Beschreibung',
                        },
                        identity: {
                            title: 'Identität',
                            subtitle: 'Prüfen Sie den Anwendungstyp und die Client-Kennung dieser Integration',
                            type: 'Anwendungstyp',
                            clientId: 'Client-ID',
                        },
                        trust: {
                            title: 'Vertrauen',
                            subtitle:
                                'Wählen Sie, ob diese Anwendung von Ihrer Organisation oder von einem externen Partner betrieben wird',
                            trusted: {
                                title: 'Vertrauenswürdige Anwendung',
                                description: 'Für Anwendungen, die Ihre Organisation besitzt und betreibt.',
                            },
                            thirdParty: {
                                title: 'Drittanbieter-Anwendung',
                                description: 'Für externe Anwendungen, die sich mit Ihrem Mandanten verbinden.',
                            },
                        },
                    },
                    authentication: {
                        authProviders: {
                            title: 'Anmeldemethoden',
                            subtitle:
                                'Wählen Sie, welche Anmeldemethoden des Mandanten in dieser Anwendung verfügbar sind.',
                            inherit: 'Anmeldemethoden des Mandanten verwenden',
                            providers: {
                                local: 'E-Mail & Passwort',
                                google: 'Google',
                                microsoft: 'Microsoft',
                            },
                            unavailable: 'Für diesen Mandanten nicht konfiguriert.',
                            empty: 'In den Mandanteneinstellungen sind keine Anmeldemethoden konfiguriert.',
                            noMethods:
                                'Mit dieser Auswahl ist keine Anmeldemethode verfügbar. Bestehende Sitzungen und Übergabe-Tickets funktionieren weiterhin.',
                        },
                        urls: {
                            title: 'Authentifizierungs-URLs',
                            subtitle:
                                'Endpunkte für Authentifizierung, Identitätssynchronisierung und CORS-Richtlinien festlegen',
                            callbackUrls: 'Callback-URLs',
                            allowedCorsOrigins: 'Zulässige CORS-Ursprünge',
                            identitySyncUrl: 'URL zur Identitätssynchronisierung',
                            appUrl: 'Anmelde-URL der Anwendung',
                        },
                        authMethods: {
                            title: 'Authentifizierungsabläufe',
                            subtitle: 'Abläufe, Token-Laufzeiten und Sicherheitsanforderungen verwalten',
                            grantTypes: 'Grant-Typen',
                            accessTokenTimeout: 'Gültigkeit des Zugriffstokens',
                            refreshTokenTimeout: 'Gültigkeit des Aktualisierungstokens',
                            clientCredentialsTimeout: 'Gültigkeit bei Client Credentials',
                            idTokenTimeout: 'Gültigkeit des ID-Tokens',
                            authCodeTimeout: 'Gültigkeit des Autorisierungscodes',
                            pkceRequired: 'PKCE erforderlich',
                            pkceRequiredInfo:
                                'PKCE beim Austausch von Autorisierungscodes gegen Tokens vorschreiben. Dies hilft zu verhindern, dass abgefangene Codes von einer anderen Anwendung verwendet werden.',
                            dpopRequired: 'DPoP erforderlich',
                            dpopImplicitInfo:
                                'DPoP kann nicht vorgeschrieben werden, solange der Implicit-Grant aktiviert ist.',
                            dpopRequiredInfo:
                                'Beim Anfordern von Zugriffstokens muss der Besitz des privaten Schlüssels nachgewiesen werden. Die Anwendung muss DPoP unterstützen.',
                            grantTypeValues: {
                                implicit: 'Implicit',
                                authorization_code: 'Authorization Code',
                                refresh_token: 'Refresh Token',
                                client_credentials: 'Client Credentials',
                            },
                            grantTypeInfos: {
                                implicit:
                                    'Ein älterer Ablauf, bei dem das Zugriffstoken direkt in der Autorisierungsantwort ausgegeben wird, typischerweise in browserbasierten Apps; aus Sicherheitsgründen nicht mehr empfohlen.',
                                authorization_code:
                                    'Ein sicherer Zwei-Schritt-Ablauf: Der Client erhält zuerst einen Autorisierungscode und tauscht ihn gegen ein Zugriffstoken – üblich für Web- und mobile Apps.',
                                refresh_token:
                                    'Ermöglicht es Clients, ein neues Zugriffstoken zu erhalten, ohne Nutzerinteraktion – verbessert Sicherheit und Nutzererlebnis.',
                                client_credentials:
                                    'Der Client authentifiziert sich (ohne Nutzer) und erhält ein Zugriffstoken, häufig für Maschine-zu-Maschine-Kommunikation.',
                            },
                            clientCredentialsNotAllowed:
                                'Um den Client-Credentials-Ablauf zu aktivieren, konfigurieren Sie eine Authentifizierungsmethode im Tab „Sicherheit“.',
                            grantTypeTypeRestriction: {
                                spa: 'Single-Page-Anwendungen können den Ablauf „Client Credentials“ nicht nutzen, da es sich um öffentliche Clients handelt.',
                                native: 'Native Anwendungen können den Ablauf „Client Credentials“ nicht nutzen, da es sich um öffentliche Clients handelt.',
                            },
                        },
                        handoff: {
                            title: 'Anwendungsübergabe',
                            subtitle:
                                'Legen Sie fest, ob diese Anwendung Tickets für die Anmeldung zwischen Anwendungen erstellen oder akzeptieren darf.',
                            issueTickets: 'Dieser Anwendung das Erstellen von Übergabe-Tickets erlauben',
                            acceptTickets: 'Anmeldung bei dieser Anwendung mit einem Übergabe-Ticket erlauben',
                        },
                        logout: {
                            title: 'Abmeldung',
                            subtitle: 'Abmeldeverhalten inklusive Weiterleitungen und Bestätigungsdialogen einrichten',
                            postLogoutUrls: 'Weiterleitungs-URLs nach Abmeldung',
                            backchannelLogoutUrl: 'Backchannel-Logout-URL',
                            alwaysShowLogoutPrompt: 'Abmeldebestätigung immer anzeigen',
                        },
                        timing: {
                            title: 'Zeiten bei der Anmeldung',
                            subtitle:
                                'Steuern Sie, wie lange Anmeldesitzungen aktiv bleiben und wie lange eine Einwilligung wiederverwendet werden kann',
                            interactionTimeout: 'Timeout der Anmeldesitzung',
                            grantTimeout: 'Gültigkeit der Einwilligung',
                        },
                    },
                    apis: {
                        title: 'API-Zugriff',
                        subtitle:
                            'Wählen Sie, welche APIs diese Anwendung anfordern darf und welche standardmäßig verwendet wird',
                        allowedResourceIds: 'Zulässige APIs',
                        defaultResourceId: 'Standard-API',
                        noDefault: 'Keine Standard-API',
                        disabled: 'Deaktiviert',
                        empty: {
                            title: 'Noch keine APIs verfügbar',
                            description:
                                'Fügen Sie in den Mandanteneinstellungen eine API hinzu, bevor Sie dieser Anwendung API-Zugriff zuweisen.',
                        },
                    },
                    experience: {
                        policies: {
                            title: 'Richtlinien',
                            subtitle: 'Links, die Nutzern während Authentifizierung und Einwilligung angezeigt werden',
                            termsOfServiceUrl: 'URL der Nutzungsbedingungen',
                            privacyPolicyUrl: 'URL der Datenschutzerklärung',
                        },
                        footerLinks: {
                            title: 'Fußzeilen-Links',
                            subtitle: 'Links in der Fußzeile der Authentifizierungsbildschirme verwalten',
                            empty: 'Es wurden noch keine Fußzeilen-Links hinzugefügt.',
                            add: 'Link hinzufügen',
                            itemFallback: 'Link {{index}}',
                            label: 'Bezeichnung',
                            url: 'URL',
                        },
                        signupAgreements: {
                            title: 'Zustimmungen bei der Registrierung',
                            subtitle: 'Vereinbarungen, die Nutzer bei der Registrierung akzeptieren müssen',
                            empty: 'Es wurden noch keine Vereinbarungen hinzugefügt.',
                            add: 'Vereinbarung hinzufügen',
                            itemFallback: 'Vereinbarung {{index}}',
                            text: 'Text der Vereinbarung',
                        },
                    },
                    security: {
                        clientAuthentication: {
                            title: 'Client-Authentifizierung',
                            subtitle:
                                'Legen Sie fest, wie sich Ihre Anwendung beim Autorisierungsserver authentifiziert',
                            endpointsAuthMethod: 'Authentifizierungsmethode',
                            clientSecret: 'Client-Secret',
                            authMethodValues: {
                                client_secret_basic: 'Client Secret (Basic Authentication)',
                                client_secret_jwt: 'Client Secret (JWT Assertion)',
                                client_secret_post: 'Client Secret (POST-Parameter)',
                                private_key_jwt: 'Private Key (JWT Assertion)',
                                none: 'Keine Authentifizierung',
                            },
                            authMethodInfos: {
                                client_secret_basic:
                                    'Die Anwendung authentifiziert sich mit einem gemeinsamen Geheimnis, das als Basic-Auth-Header gesendet wird.',
                                client_secret_jwt:
                                    'Die Anwendung erstellt ein signiertes JWT mit dem gemeinsamen Geheimnis zur Authentifizierung.',
                                client_secret_post:
                                    'Die Anwendung sendet das gemeinsame Geheimnis im Body statt im Header.',
                                private_key_jwt:
                                    'Die Anwendung signiert ein JWT mit einem privaten Schlüssel zur Authentifizierung.',
                                none: 'Die Anwendung verwendet keine Authentifizierungsmethode.',
                            },
                            authMethodTypeRestriction: {
                                spa: 'Single-Page-Anwendungen können keine Authentifizierungsmethoden nutzen, da es sich um öffentliche Clients handelt.',
                                native: 'Native Anwendungen können keine Authentifizierungsmethoden nutzen, da es sich um öffentliche Clients handelt.',
                            },
                        },
                        publicKeys: {
                            title: 'Öffentliche Schlüssel',
                            subtitle: 'Öffentliche Schlüssel für die Authentifizierung mit Private Key JWT verwalten',
                            empty: 'Es wurden noch keine öffentlichen Schlüssel hinzugefügt.',
                            unavailable: {
                                title: 'Öffentliche Schlüssel sind für diese Authentifizierungsmethode nicht aktiv',
                                description:
                                    'Öffentliche Schlüssel werden nur mit Private Key JWT verwendet. Stellen Sie die Authentifizierungsmethode auf Private Key JWT um, um Schlüssel hinzuzufügen oder zu verwalten.',
                                descriptionWithKeys:
                                    'Öffentliche Schlüssel werden nur mit Private Key JWT verwendet. Die Schlüssel bleiben gespeichert und werden wieder verwendet, wenn Sie zurückwechseln.',
                            },
                            rsaLabel: 'RSA-Öffentlicher Schlüssel',
                            add: 'Öffentlichen Schlüssel hinzufügen',
                            view: 'Öffentlichen Schlüssel anzeigen',
                            remove: 'Entfernen',
                            removeConfirm: {
                                title: 'Öffentlichen Schlüssel entfernen',
                                message: 'Möchten Sie den öffentlichen Schlüssel „{{kid}}“ wirklich entfernen?',
                            },
                            dialog: {
                                title: 'Öffentlichen Schlüssel hinzufügen',
                                kid: 'Schlüssel-ID',
                                pem: 'Öffentlicher Schlüssel (PEM)',
                                help: 'Fügen Sie einen RSA-Öffentlichen Schlüssel im PEM-Format ein. Lassen Sie die Schlüssel-ID leer, um sie automatisch zu erzeugen.',
                            },
                            detailsDialog: {
                                title: 'Details zum öffentlichen Schlüssel',
                                kid: 'Schlüssel-ID',
                                type: 'Typ',
                                publicKey: 'Öffentlicher Schlüssel',
                                publicKeyHelp:
                                    'Prüfen Sie den gespeicherten öffentlichen Schlüssel oder kopieren Sie ihn zur Fehleranalyse.',
                                copy: 'Öffentlichen Schlüssel kopieren',
                            },
                        },
                    },
                },
            },
            identities: {
                list: {
                    title: 'Identitäten',
                    sidebar: {
                        title: 'Identitäten',
                    },
                    toolbar: {
                        title: 'Identitäten',
                        counter_zero: 'Keine Identitäten',
                        counter_one: '{{count, number}} Identität',
                        counter_other: '{{count, number}} Identitäten',
                        search: 'Primäre E-Mail',
                        newIdentity: 'Neue Identität',
                    },
                    empty: {
                        title: 'Noch keine Identitäten',
                        subtitle: 'Wenn sich Nutzer bei Ihren Anwendungen anmelden, erscheinen sie hier.',
                        actionCreate: 'Neue Identität',
                    },
                    newIdentity: {
                        title: 'Neue Identität',
                        loadAuthProvidersError:
                            'Die Authentifizierungseinstellungen für diesen Mandanten konnten nicht geladen werden.',
                        noLocalProvider:
                            'E-Mail- und Passwort-Anmeldung ist für diesen Mandanten nicht aktiviert. Aktivieren Sie die lokale Anmeldemethode unter Authentifizierung, bevor Sie hier Identitäten anlegen.',
                        email: 'Primäre E-Mail',
                        emailVerified: 'E-Mail bestätigt',
                        activate: 'Aktiv (sofortige Anmeldung möglich)',
                        language: 'Sprache',
                        country: 'Land / Region',
                        mfaRequiredHint:
                            'Für aktive Identitäten ist für diesen Mandanten ein zweiter Faktor erforderlich. Geben Sie ein Authenticator-Geheimnis an und/oder aktivieren Sie die E-Mail-MFA-Option.',
                        password: 'Passwort',
                        passwordHint:
                            'Erforderlich für aktive Identitäten. Optional für ausstehende Identitäten (stattdessen wird ein temporäres Passwort per E-Mail versendet).',
                        totpSecret: 'Authenticator (TOTP)-Geheimnis',
                        totpSecretHint:
                            'Base32-Geheimnis aus Ihrem Authenticator-Registrierungsflow, falls Sie jetzt TOTP einrichten.',
                        includeEmailMfa: 'E-Mail-MFA für diese Identität registrieren',
                        claimsJson: 'Benutzerdefinierte Claims (JSON-Objekt)',
                        claimsJsonHint:
                            'Optional. Flache String-Schlüssel mit JSON-serialisierbaren Werten, z. B. {"name":"Ada Lovelace"}.',
                        claimsInvalid: 'Claims müssen ein JSON-Objekt sein (kein Array und kein Primitiv).',
                    },
                    table: {
                        columnIdentity: 'Identität',
                        columnStatus: 'Status',
                        columnDates: 'Aktivität',
                        columnProviders: 'Anmeldemethoden',
                        signedUpAt: 'Registriert am',
                        lastSeenAt: 'Zuletzt gesehen',
                        emailVerified: 'E-Mail bestätigt',
                        locale: 'Gebietsschema',
                        statusValues: {
                            created: 'Erstellt',
                            active: 'Aktiv',
                            blocked: 'Gesperrt',
                        },
                        providers: {
                            local: 'E-Mail / Passwort',
                            google: 'Google',
                            microsoft: 'Microsoft',
                        },
                        actions: {
                            revokeAccess: 'Sitzungen widerrufen',
                            openMenu: 'Aktionen für die Identität',
                            block: 'Identität sperren',
                            delete: 'Identität löschen',
                        },
                        confirmRevokeAccess: {
                            title: 'Sitzungen widerrufen',
                            message:
                                '„{{displayName}}“ wird auf allen Geräten abgemeldet; ausgestellte Tokens werden ungültig. Eine erneute Anmeldung bleibt möglich, solange die Identität nicht gesperrt ist.',
                        },
                        confirmBlock: {
                            title: 'Identität sperren',
                            message:
                                '„{{displayName}}“ kann sich danach nicht mehr anmelden. Aktive Sitzungen enden und Tokens werden widerrufen.',
                        },
                        confirmDelete: {
                            title: 'Identität löschen',
                            message:
                                'Möchten Sie „{{displayName}}“ und die zugehörigen Anmeldedaten dauerhaft löschen? Aktive Sitzungen enden und Tokens werden widerrufen. Konten in verbundenen Anwendungen werden nicht gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
                        },
                    },
                },
            },
            users: {
                title: 'Administratoren verwalten',
                inviteUser: 'Administrator einladen',
                user: {
                    name: 'Name',
                    email: 'E-Mail',
                    owner: 'Inhaber',
                    permissions: 'Berechtigungen',
                    restrictions: 'Einschränkungen',
                    ownerAllPermissions: 'Inhaber haben alle Berechtigungen',
                    ownerNoRestrictions: 'Inhaber haben keine Einschränkungen',
                },
                createInvitation: {
                    title: 'Administratoreinladung',
                    invite: 'Einladen',
                },
                list: {
                    title: 'Administratoren',
                    counter_zero: '0 Administratoren',
                    counter_one: '{{count, number}} Administrator',
                    counter_other: '{{count, number}} Administratoren',
                    name: 'Name',
                    email: 'E-Mail',
                    owner: 'Inhaber',
                    edit: {
                        title: 'Administrator bearbeiten',
                        name: 'Name',
                        email: 'E-Mail',
                    },
                    delete: {
                        title: 'Administrator löschen',
                        message:
                            'Möchten Sie den Administrator „{{userName}}“ wirklich aus dem aktuellen Mandanten löschen?',
                    },
                },
                invitations: {
                    title: 'Einladungen',
                    list: {
                        name: 'Name',
                        email: 'E-Mail',
                        status: 'Status',
                        statusValue: {
                            pending: 'Ausstehend',
                            delivered: 'Zugestellt',
                            error: 'Fehler',
                        },
                        resend: 'Erneut senden',
                    },
                    delete: {
                        title: 'Einladung löschen',
                        message: 'Möchten Sie die Einladung wirklich löschen?',
                    },
                    empty: {
                        title: 'Keine ausstehenden Einladungen',
                        subtitle: 'Mit Einladungen fügen Sie neue Administratoren zu Ihrem Mandanten hinzu',
                        actionCreateInvitation: 'Administrator einladen',
                    },
                },
            },
            authProviders: {
                title: 'Anmeldemethoden',
                badge: 'Mandantenzugriff',
                limit: 'Eine Einrichtung pro Anbieter',
                heading: 'Legen Sie fest, wie sich Nutzer anmelden können',
                description:
                    'Richten Sie die für diesen Mandanten verfügbaren Anmeldemethoden ein. Jeder Anbieter kann nur einmal verbunden und bei Bedarf angepasst werden.',
                empty: {
                    title: 'Noch keine Anmeldemethode verbunden',
                    description:
                        'Nutzer können sich erst anmelden, wenn Sie mindestens einen Anbieter für diesen Mandanten eingerichtet haben.',
                },
                status: {
                    connected: 'Aktiviert',
                    notConfigured: 'Nicht eingerichtet',
                },
                actions: {
                    setUp: 'Einrichten',
                    edit: 'Verwalten',
                    remove: 'Anmeldemethode entfernen',
                },
                values: {
                    enabled: 'Aktiviert',
                    disabled: 'Deaktiviert',
                },
                dangerZone: {
                    cardTitle: 'Anmeldemethode entfernen',
                    cardDescription:
                        'Wenn Sie die Anmeldung über {{method}} entfernen, können sich alle derzeitigen Nutzer dieser Methode nicht mehr bei diesem Mandanten authentifizieren.',
                    confirmTitle: 'Anmeldung über {{method}} entfernen?',
                    confirmDescription:
                        'Die Anmeldung über {{method}} wird sofort aus diesem Mandanten entfernt. Alle derzeitigen Nutzer können sich damit nicht mehr anmelden.',
                },
                providers: {
                    local: {
                        title: 'E-Mail & Passwort',
                        cardDescription:
                            'Ermöglichen Sie die Registrierung mit E-Mail und Passwort und ergänzen Sie bei Bedarf Verifizierung, MFA und Migration.',
                        emptyMessage:
                            'Diese Anmeldemethode ist noch nicht konfiguriert. Richten Sie sie ein, um direkte Anmeldung mit E-Mail und Passwort für diesen Mandanten zu erlauben.',
                        highlights: {
                            passwords: 'Passwörter',
                            signup: 'Registrierung',
                            mfa: 'Mehrfaktor-Authentifizierung',
                        },
                        summary: {
                            passwords: 'Passwortrichtlinie',
                            signup: 'Registrierung',
                            emailVerification: 'E-Mail-Bestätigung',
                            mfa: 'MFA',
                            required: 'Erforderlich',
                            optional: 'Optional',
                        },
                        dialog: {
                            createTitle: 'E-Mail & Passwort einrichten',
                            editTitle: 'E-Mail & Passwort bearbeiten',
                        },
                        password: {
                            title: 'Passwortregeln',
                            description:
                                'Legen Sie fest, wie stark Passwörter sein sollen und wie der Passwort-Reset funktionieren soll.',
                            strength: 'Passwortstärke',
                            minLength: 'Mindestlänge',
                            resetTokenTtl: 'Gültigkeit des Reset-Links',
                            requireConfirmation: 'Passwortbestätigung verlangen',
                            strengthValues: {
                                none: 'Keine Vorgaben',
                                low: 'Niedrig',
                                fair: 'Mittel',
                                good: 'Gut',
                                excellent: 'Sehr stark',
                            },
                        },
                        emailVerification: {
                            title: 'E-Mail-Bestätigung',
                            description:
                                'Legen Sie fest, ob die E-Mail-Bestätigung genutzt wird und wie streng die Anforderung ist.',
                            enabled: 'E-Mail-Bestätigung aktivieren',
                            requirement: 'Anforderung',
                            tokenTtl: 'Gültigkeit des Bestätigungslinks',
                            resendWait: 'Wartezeit vor erneutem Senden',
                            requirementValues: {
                                optional: 'Optional',
                                required: 'Erforderlich',
                            },
                        },
                        signup: {
                            title: 'Registrierung',
                            description:
                                'Steuern Sie, ob neue Nutzer ein Konto anlegen dürfen und ob die Registrierung geschützt ist.',
                            enabled: 'Selbstregistrierung erlauben',
                            blockDisposableEmails: 'Wegwerf-E-Mail-Adressen blockieren',
                            captcha: {
                                enabled: 'Registrierung mit CAPTCHA schützen',
                                key: 'CAPTCHA-Site-Key',
                                secret: 'CAPTCHA-Geheimnis',
                                minScore: 'Mindest-Score',
                            },
                        },
                        mfa: {
                            title: 'Mehrfaktor-Authentifizierung',
                            description:
                                'Bieten Sie einen zweiten Faktor optional oder verbindlich an und wählen Sie die verfügbaren Methoden.',
                            enabled: 'Mehrfaktor-Authentifizierung aktivieren',
                            requirement: 'Anforderung',
                            promptAtSignup: 'Bei Registrierung nachfragen',
                            factors: 'Verfügbare Faktoren',
                            requirementValues: {
                                optional: 'Optional',
                                required: 'Erforderlich',
                            },
                            factorValues: {
                                totp: 'Authenticator-App',
                                email: 'Code per E-Mail',
                            },
                        },
                        accountMigration: {
                            title: 'Kontomigration',
                            description:
                                'Verbinden Sie einen bestehenden Identitätsspeicher, damit Nutzer bei der ersten Anmeldung migriert werden können.',
                            enabled: 'Kontomigration aktivieren',
                            authMethod: 'Validierungsmethode',
                            validationEndpoint: 'Validierungs-Endpunkt',
                            confirmationEndpoint: 'Bestätigungs-Endpunkt',
                            createIdentityWithMigrationId: 'Migrations-ID bei der erstellten Identität beibehalten',
                            authMethodValues: {
                                selfAuth: 'Anbieter-Zugangsdaten',
                                apiKey: 'API-Schlüssel',
                                jwt: 'JWT',
                            },
                        },
                    },
                    google: {
                        title: 'Google',
                        cardDescription:
                            'Erlauben Sie die Anmeldung mit Google und steuern Sie, welche Profildaten angefordert und bei jeder Anmeldung synchronisiert werden.',
                        emptyMessage:
                            'Diese Anmeldemethode ist noch nicht eingerichtet. Richten Sie sie ein, damit sich Nutzer mit ihrem Google-Konto anmelden können.',
                        highlights: {
                            oauth: 'OAuth',
                            profile: 'Profilsynchronisierung',
                            scopes: 'Eigene Scopes',
                        },
                        summary: {
                            clientId: 'Client-ID',
                            scopes: 'Scopes',
                            scopeCount_one: '1 Scope',
                            scopeCount_other: '{{count, number}} Scopes',
                            sync: 'Profilsynchronisierung',
                            syncOn: 'Bei jeder Anmeldung',
                            syncOff: 'Nur manuell',
                            emailVerification: 'E-Mail-Bestätigung',
                            required: 'Erforderlich',
                            optional: 'Optional',
                        },
                        dialog: {
                            createTitle: 'Google-Anmeldung einrichten',
                            editTitle: 'Google-Anmeldung bearbeiten',
                        },
                        connection: {
                            title: 'Verbindung',
                            description:
                                'Hinterlegen Sie die Google-App-Zugangsdaten und wählen Sie die anzufordernden Scopes.',
                            clientId: 'Client-ID',
                            clientSecret: 'Client-Secret',
                            scopes: 'Scopes',
                            scopesPlaceholder: 'Scope eingeben und Enter drücken …',
                            invalidScope: 'Scopes müssen eindeutig sein.',
                        },
                        emailVerification: {
                            title: 'E-Mail-Bestätigung',
                            description:
                                'Legen Sie fest, ob Google-Anmeldungen eine Authy-E-Mail-Bestätigung auslösen und wie streng die Anforderung ist.',
                            enabled: 'E-Mail-Bestätigung aktivieren',
                            requirement: 'Anforderung',
                            requirementValues: {
                                optional: 'Optional',
                                required: 'Erforderlich',
                            },
                            tokenTtl: 'Gültigkeit des Bestätigungslinks',
                            resendWait: 'Wartezeit vor erneutem Senden',
                        },
                        profile: {
                            title: 'Profilsynchronisierung',
                            description:
                                'Legen Sie fest, ob Google-Profildaten bei jeder Anmeldung aktualisiert werden sollen.',
                            syncOnLogin: 'Profildaten bei Anmeldung synchronisieren',
                        },
                    },
                    microsoft: {
                        title: 'Microsoft',
                        cardDescription:
                            'Erlauben Sie die Anmeldung mit Microsoft und steuern Sie, welche Verzeichnisdaten bei jeder Anmeldung angefordert und synchronisiert werden.',
                        emptyMessage:
                            'Diese Anmeldemethode ist noch nicht eingerichtet. Richten Sie sie ein, damit sich Nutzer mit ihrem Microsoft-Konto anmelden können.',
                        highlights: {
                            oauth: 'OAuth',
                            profile: 'Profilsynchronisierung',
                            scopes: 'Zusätzliche Scopes',
                        },
                        summary: {
                            clientId: 'Client-ID',
                            scopes: 'Scopes',
                            scopeCount_one: '1 Scope',
                            scopeCount_other: '{{count, number}} Scopes',
                            sync: 'Profilsynchronisierung',
                            syncOn: 'Bei jeder Anmeldung',
                            syncOff: 'Nur manuell',
                            emailVerification: 'E-Mail-Bestätigung',
                            required: 'Erforderlich',
                            optional: 'Optional',
                        },
                        dialog: {
                            createTitle: 'Microsoft-Anmeldung einrichten',
                            editTitle: 'Microsoft-Anmeldung bearbeiten',
                        },
                        connection: {
                            title: 'Verbindung',
                            description:
                                'Hinterlegen Sie die Microsoft-App-Zugangsdaten und wählen Sie zusätzliche Scopes aus, die angefordert werden sollen.',
                            clientId: 'Client-ID',
                            clientSecret: 'Client-Secret',
                            scopes: 'Scopes',
                            scopesPlaceholder: 'Scope eingeben und Enter drücken …',
                            invalidScope: 'Scopes müssen eindeutig sein.',
                        },
                        emailVerification: {
                            title: 'E-Mail-Bestätigung',
                            description:
                                'Legen Sie fest, ob Microsoft-Anmeldungen eine Authy-E-Mail-Bestätigung auslösen und wie streng die Anforderung ist.',
                            enabled: 'E-Mail-Bestätigung aktivieren',
                            requirement: 'Anforderung',
                            requirementValues: {
                                optional: 'Optional',
                                required: 'Erforderlich',
                            },
                            tokenTtl: 'Gültigkeit des Bestätigungslinks',
                            resendWait: 'Wartezeit vor erneutem Senden',
                        },
                        profile: {
                            title: 'Profilsynchronisierung',
                            description:
                                'Legen Sie fest, ob Microsoft-Profildaten bei jeder Anmeldung aktualisiert werden sollen.',
                            syncOnLogin: 'Profildaten bei Anmeldung synchronisieren',
                        },
                    },
                },
            },
            apis: {
                title: 'APIs',
                heading: 'Mandanten-APIs verwalten',
                description:
                    'Richten Sie die in diesem Mandanten verfügbaren APIs ein – inklusive Audience, Tokenformat und anforderbarer Scopes.',
                status: {
                    enabled: 'Aktiviert',
                    disabled: 'Deaktiviert',
                },
                actions: {
                    add: 'API hinzufügen',
                    manage: 'Verwalten',
                },
                empty: {
                    title: 'Noch keine APIs',
                    description:
                        'Fügen Sie eine API hinzu, um Audiences, Zugriffstoken und Scopes zu definieren, die Ihre Anwendungen nutzen können.',
                    action: 'API hinzufügen',
                },
                card: {
                    noDescription: 'Noch keine Beschreibung hinterlegt.',
                    apiUrl: 'API-URL',
                    audience: 'Token-Audience',
                    audienceUsesIndicator: 'Entspricht der API-URL',
                    accessTokens: 'Zugriffstoken',
                    accessTokensValue: '{{format}} • {{ttl}} Sekunden',
                    scopes: 'Scopes',
                    scopeCount_zero: 'Keine Scopes',
                    scopeCount_one: '{{count, number}} Scope',
                    scopeCount_other: '{{count, number}} Scopes',
                },
                dialog: {
                    createTitle: 'API hinzufügen',
                    editTitle: 'API bearbeiten',
                    basic: {
                        title: 'Grundlagen',
                        description: 'Wählen Sie einen klaren Namen und ob Anwendungen diese API anfordern dürfen.',
                        enabled: 'API verfügbar',
                        name: 'Name',
                        descriptionField: 'Beschreibung',
                    },
                    resource: {
                        title: 'Ressource',
                        description: 'Definieren Sie die API-URL und den Audience-Wert in den Zugriffstoken.',
                        indicator: 'API-URL',
                        audienceMode: 'Token-Audience',
                        audienceModeValues: {
                            indicator: 'API-URL verwenden',
                            custom: 'Eigene Audience',
                        },
                        audienceValue: 'Eigene Audience',
                    },
                    tokens: {
                        title: 'Zugriffstoken',
                        description:
                            'Wählen Sie das Tokenformat, das Anwendungen erhalten, wenn sie diese API anfordern.',
                        format: 'Format der Zugriffstoken',
                        formatValues: {
                            opaque: 'Opaque',
                            jwt: 'JWT',
                        },
                        ttl: 'Gültigkeit der Zugriffstoken',
                        jwtHelp:
                            'JWT-Zugriffstoken werden mit den Signierschlüsseln Ihres Mandanten per RS256 signiert.',
                    },
                    scopes: {
                        title: 'Scopes',
                        description:
                            'Fügen Sie die Berechtigungen hinzu, die Anwendungen für diese API anfordern können.',
                        empty: 'Es wurden noch keine Scopes hinzugefügt.',
                        add: 'Scope hinzufügen',
                        scopeFallback: 'Scope {{index}}',
                        name: 'Scope-Name',
                        icon: 'Symbol',
                        display: 'Anzeige',
                        displayTitle: 'Titel',
                        displayDescription: 'Beschreibung',
                    },
                    remove: {
                        title: 'API entfernen',
                        description:
                            'Wenn Sie diese API entfernen, können Anwendungen keine Token mehr für sie anfordern. Bestehende Zuweisungen werden automatisch entfernt.',
                        action: 'API entfernen',
                        confirmTitle: 'API entfernen?',
                        confirmDescription:
                            '{{name}} wird sofort entfernt und aus allen Anwendungen entfernt, die sie derzeit nutzen.',
                    },
                },
            },
            settings: {
                title: 'Einstellungen',
                general: {
                    title: 'Allgemein',
                    profile: {
                        title: 'Profil',
                        description: 'Diese Angaben bestimmen, wie der Mandant dargestellt wird',
                        changeAvatar: 'Avatar ändern',
                        avatarInfo: 'JPG, GIF oder PNG, maximal 1 MB.',
                        name: 'Mandantenname',
                        language: 'Standardsprache',
                    },
                    localization: {
                        title: 'Lokalisierung',
                        description:
                            'Legen Sie das Standard-Gebietsschema und die verfügbaren Sprachen für die Authentifizierungs-Oberfläche fest.',
                        language: 'Standardsprache',
                        country: 'Standardland',
                        availableLanguages: 'Verfügbare Sprachen',
                    },
                    dangerZone: {
                        title: 'Gefahrenbereich',
                        description: 'Seien Sie bei Aktionen in diesem Bereich besonders vorsichtig',
                        delete: {
                            title: '{{tenant}} löschen',
                            description:
                                'Alle Daten von „{{tenant}}“ dauerhaft löschen.\nAchtung: Dies kann nicht rückgängig gemacht werden!',
                            action: 'Löschen',
                            confirmation: {
                                title: '{{tenant}} löschen',
                                message:
                                    'Möchten Sie „{{tenantName}}“ und alle zugehörigen Daten wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
                            },
                        },
                    },
                    slug: {
                        title: 'Kennung',
                        description:
                            'Die Kennung wird für eine lesbare URL verwendet und als Absendername in E-Mails genutzt.',
                        label: 'Kennung',
                        updateSlug: 'Kennung aktualisieren',
                        note: 'Hinweis: Wenn Ihre URL bereits genutzt wird und Sie die Kennung ändern, werden alle alten URLs ungültig.',
                    },
                },
                appearance: {
                    title: 'Darstellung',
                },
                accountApp: {
                    title: 'Konto-App',
                    appearance: {
                        title: 'Darstellung',
                        description: 'Passen Sie Farben, helles und dunkles Design sowie das Favicon der Konto-App an.',
                        favicon: 'Favicon',
                        faviconInfo: 'Ohne eigenes Favicon wird das Profilbild des Mandanten verwendet.',
                        allowDarkTheme: 'Dunkles Design erlauben',
                        darkThemeInfo: 'Wenn aktiviert, wird die Systemeinstellung der jeweiligen Person verwendet.',
                        schemes: {
                            light: 'Helles Design',
                            dark: 'Dunkles Design',
                        },
                        colors: {
                            accent: 'Akzentfarbe',
                            pageBackground: 'Seitenhintergrund',
                            surfaceBackground: 'Flächenhintergrund',
                        },
                    },
                    availability: {
                        title: 'Verfügbarkeit',
                        description:
                            'Ermöglichen Sie die Verwaltung von Passwort und Mehrfaktor-Authentifizierung in einer eigenen Konto-App.',
                        status: {
                            enabled: 'Aktiviert',
                            disabled: 'Deaktiviert',
                        },
                        content: {
                            enabledTitle: 'Die Kontoverwaltung ist für diesen Mandanten verfügbar.',
                            enabledDescription:
                                'Identitäten können Passwort und Mehrfaktor-Einstellungen in einer eigenen Konto-App verwalten.',
                            disabledTitle: 'Die Kontoverwaltung ist derzeit deaktiviert.',
                            disabledDescription:
                                'Gespeicherte Einstellungen und die eigene Domain bleiben erhalten, wenn die Konto-App deaktiviert ist.',
                        },
                        actions: {
                            enable: 'Kontoverwaltung aktivieren',
                            disable: 'Kontoverwaltung deaktivieren',
                        },
                        messages: {
                            enabled: 'Kontoverwaltung aktiviert.',
                            disabled: 'Kontoverwaltung deaktiviert.',
                        },
                        open: 'Konto-App öffnen',
                    },
                    customDomain: {
                        title: 'Eigene Domain für die Konto-App',
                        description: 'Stellen Sie die Konto-App dieses Mandanten unter Ihrer eigenen Domain bereit.',
                        domain: 'Domain',
                        stateDescription: {
                            none: 'Verwenden Sie Ihre eigene Domain für die Konto-App. Die reguläre Authy-Adresse bleibt weiterhin verfügbar.',
                            pending:
                                'Ihre eigene Domain wurde angelegt. Schließen Sie die folgenden Einrichtungsschritte ab, um sie zu verwenden.',
                            done: 'Alle Einrichtungsschritte sind abgeschlossen. Ihre eigene Domain ist aktiv.',
                        },
                        actions: {
                            remove: 'Eigene Domain entfernen',
                            setup: 'Eigene Domain einrichten',
                            refreshSetup: 'Einrichtung aktualisieren',
                            refreshSetupHint:
                                'DNS-Änderungen können etwas Zeit brauchen, bis sie überall sichtbar sind. Wenn die Verifizierung fehlschlägt, warten Sie kurz und versuchen Sie es erneut.',
                        },
                        removeConfirm: {
                            title: 'Eigene Domain für die Konto-App entfernen',
                            message:
                                'Möchten Sie die eigene Domain für die Konto-App dieses Mandanten wirklich entfernen?',
                        },
                    },
                },
                authentication: {
                    title: 'Authentifizierung',
                    signup: {
                        title: 'Registrierungslimit pro IP-Adresse',
                        description:
                            'Begrenzen Sie neue Konten von derselben IP-Adresse über alle Anwendungen und Anmeldemethoden hinweg. Personen im selben Netzwerk teilen sich dieses Kontingent.',
                        enabled: 'Registrierungen pro IP-Adresse begrenzen',
                        maxRegistrations: 'Maximale Registrierungen',
                        window: 'Zeitfenster',
                        windowChanged:
                            'Wenn Sie das Zeitfenster verlängern, kann es bis zum Ablauf eines vollständigen neuen Zeitfensters dauern, bis das neue Limit vollständig wirksam ist. In dieser Zeit können über manche IP-Adressen möglicherweise mehr Konten registriert werden, als das konfigurierte Limit erlaubt.',
                    },
                    loginFlow: {
                        title: 'Anmeldung & Ablauf',
                        description:
                            'Legen Sie fest, wie Anwendungen sich gegenüber diesem Mandanten authentifizieren dürfen.',
                        allowAuthTroughIframe: 'Authentifizierung über iFrame erlauben',
                        allowImplicitFlow: 'Implicit Flow erlauben',
                    },
                    customDomain: {
                        title: 'Eigene Auth-Domain',
                        description:
                            'Stellen Sie die Authentifizierung dieses Mandanten über Ihre eigene Domain bereit.',
                        domain: 'Domain',
                        dnsRecord: {
                            type: 'Typ',
                            name: 'Name',
                            value: 'Wert',
                            status: 'Status',
                            verified: 'Verifiziert',
                            pending: 'Ausstehend',
                        },
                        stateDescription: {
                            none: 'Konfigurieren Sie eine eigene Domain für Anmeldung, Registrierung und Passwort-Wiederherstellung. Pro Mandant ist eine eigene Auth-Domain möglich.',
                            pending:
                                'Ihre eigene Domain wurde angelegt. Schließen Sie die folgenden Einrichtungsschritte ab, um sie zu verwenden.',
                            done: 'Alle Einrichtungsschritte sind abgeschlossen. Ihre eigene Domain ist aktiv.',
                        },
                        actions: {
                            remove: 'Eigene Domain entfernen',
                            setup: 'Eigene Domain einrichten',
                            refreshSetup: 'Einrichtung aktualisieren',
                            refreshSetupHint:
                                'DNS-Änderungen können etwas Zeit brauchen, bis sie überall sichtbar sind. Wenn die Verifizierung fehlschlägt, warten Sie kurz und versuchen Sie es erneut.',
                        },
                        removeConfirm: {
                            title: 'Eigene Auth-Domain entfernen',
                            message: 'Möchten Sie die eigene Auth-Domain wirklich aus diesem Mandanten entfernen?',
                        },
                    },
                    session: {
                        title: 'Sitzung',
                        description: 'Steuern Sie, wie Sitzungen bestehen bleiben und wann sie ablaufen.',
                        persistent: 'Dauerhafte Sitzungen',
                        persistenceMode: 'Persistenzmodus',
                        persistentOptions: {
                            persistent: {
                                title: 'Dauerhaft',
                                description:
                                    'Sitzungen bleiben über Browser-Neustarts hinweg bestehen, bis sie ablaufen oder widerrufen werden.',
                            },
                            sessionOnly: {
                                title: 'Nur Sitzung',
                                description:
                                    'Sitzungen enden beim Schließen des Browsers, auch wenn die Lebensdauer noch nicht erreicht ist.',
                            },
                        },
                        idleTtl: 'Leerlauf-Timeout',
                        maxTtl: 'Maximale Lebensdauer',
                    },
                    logout: {
                        title: 'Abmeldung',
                        description: 'Konfigurieren Sie die Abmeldung für Endnutzer.',
                        requireLogoutConfirmation: 'Abmeldebestätigung verlangen',
                    },
                },
                scopes: {
                    title: 'Scopes & Claims',
                    scopes: {
                        title: 'Scopes',
                        description: 'Verwalten Sie verfügbare Scopes und die Claims, die sie freigeben.',
                        empty: 'Noch keine Scopes konfiguriert.',
                        scopeFallback: 'Scope {{index}}',
                        add: 'Scope hinzufügen',
                        name: 'Scope-Name',
                        icon: 'Symbol',
                        claims: 'Claims',
                        claimsPlaceholder: 'Claim-Namen eingeben und Enter drücken …',
                        display: {
                            title: 'Anzeige',
                            language: 'Sprache',
                            fieldTitle: 'Titel',
                            fieldDescription: 'Beschreibung',
                            completion: '{{count}} / {{total}} Sprachen vollständig',
                        },
                        errors: {
                            invalidClaim: 'Claims müssen eindeutig sein und einen gültigen Claim-Identifier verwenden.',
                        },
                    },
                    additionalClaims: {
                        title: 'Zusätzliche Claims',
                        description: 'Geben Sie zusätzliche Claims frei, die keinem eigenen Scope zugeordnet sind.',
                        label: 'Claims',
                        placeholder: 'Claim-Namen eingeben und Enter drücken …',
                        errors: {
                            invalidClaim: 'Claims müssen eindeutig sein und einen gültigen Claim-Identifier verwenden.',
                        },
                    },
                },
                security: {
                    title: 'Sicherheit',
                    cookies: {
                        title: 'Cookies',
                        description: 'Signaturmaterial für Cookies und automatische Rotation verwalten.',
                        availableKeys_one: 'Derzeit ist 1 Cookie-Schlüssel verfügbar.',
                        availableKeys_other: 'Derzeit sind {{count}} Cookie-Schlüssel verfügbar.',
                        automation: {
                            title: 'Automatische Rotation',
                            description: 'Cookie-Schlüssel automatisch nach einem Zeitplan rotieren.',
                            retentionNote:
                                'Ältere Schlüssel bleiben nach der Rotation vorübergehend verfügbar und werden entfernt, sobald das Limit gespeicherter Schlüssel erreicht ist.',
                            nextRotation: 'Nächste automatische Rotation: {{date}}',
                        },
                        autoRotate: 'Schlüssel automatisch rotieren',
                        rotationInterval: 'Rotationsintervall',
                        maxKeys: 'Maximal gespeicherte Schlüssel',
                        management: {
                            rotate: 'Rotieren',
                            rotateTitle: 'Cookie-Schlüssel rotieren',
                            rotateDescription:
                                'Einen neuen aktiven Cookie-Schlüssel erzeugen und ältere Schlüssel bis zum Limit behalten.',
                        },
                        rotateConfirm: {
                            title: 'Cookie-Schlüssel rotieren?',
                            message:
                                'Ein neuer Cookie-Schlüssel wird sofort aktiv; ältere Schlüssel werden nur bis zum konfigurierten Limit aufbewahrt.',
                        },
                    },
                    signingKeys: {
                        title: 'Signierschlüssel',
                        description: 'Automatische Rotation der Mandanten-Signierschlüssel verwalten.',
                        empty: 'Derzeit sind keine Signierschlüssel verfügbar.',
                        list: {
                            title: 'Verfügbare Signierschlüssel',
                            description:
                                'Prüfen Sie den Schlüsselstatus hier und öffnen Sie das Aktionsmenü für Details und Verwaltung.',
                            showRevoked_one: '1 widerrufenen Schlüssel anzeigen',
                            showRevoked_other: '{{count}} widerrufene Schlüssel anzeigen',
                            hideRevoked: 'Widerrufene Schlüssel ausblenden',
                        },
                        automation: {
                            title: 'Automatische Rotation',
                            description:
                                'Legen Sie fest, ob Signierschlüssel automatisch rotieren und wie oft ein neuer Schlüssel vorbereitet werden soll.',
                            retentionNote:
                                'Vorherige Schlüssel bleiben nach der Rotation vorübergehend zur Verifizierung erhalten und werden später automatisch widerrufen.',
                            nextRotation: 'Nächste automatische Rotation: {{date}}',
                        },
                        autoRotate: 'Signierschlüssel automatisch rotieren',
                        rotationInterval: 'Rotationsintervall',
                        statusValues: {
                            current: 'Aktuell',
                            next: 'Nächster',
                            previous: 'Vorheriger',
                            revoked: 'Widerrufen',
                        },
                        actions: {
                            openMenu: 'Aktionen öffnen',
                            details: 'Details',
                            revoke: 'Widerrufen',
                        },
                        management: {
                            title: 'Manuelle Schlüsselverwaltung',
                            description:
                                'Nutzen Sie diese Aktionen, wenn Sie die Signierschlüssel vor dem geplanten Intervall rotieren müssen.',
                            rotate: 'Rotieren',
                            rotateTitle: 'Schlüssel rotieren',
                            rotateDescription:
                                'Den vorbereiteten nächsten Signierschlüssel zum aktuellen machen und einen neuen nächsten Schlüssel erzeugen. Der ausgelagerte Schlüssel bleibt zur Verifizierung verfügbar.',
                            rotateAndRevoke: 'Rotieren und widerrufen',
                            rotateAndRevokeTitle: 'Aktuellen Schlüssel rotieren und widerrufen',
                            rotateAndRevokeDescription:
                                'Den nächsten Signierschlüssel übernehmen, einen neuen nächsten Schlüssel erzeugen und den ersetzten aktuellen Schlüssel sofort widerrufen.',
                            unavailable:
                                'Die manuelle Rotation erfordert einen aktuellen und einen nächsten Signierschlüssel.',
                        },
                        detailsDialog: {
                            title: 'Details zum Signierschlüssel',
                            id: 'ID',
                            status: 'Status',
                            createdAt: 'Erstellt',
                            revokedAt: 'Widerrufen',
                            publicKey: 'Öffentlicher Schlüssel',
                            publicKeyHelp: 'Verwenden Sie diesen Schlüssel überall, wo eine Signaturprüfung nötig ist.',
                            copy: 'Öffentlichen Schlüssel kopieren',
                            notRevoked: 'Nicht widerrufen',
                            unknownDate: 'Unbekannt',
                        },
                        revokeConfirm: {
                            title: 'Signierschlüssel widerrufen',
                            current:
                                'Signierschlüssel {{keyId}} wirklich widerrufen? Der nächste Schlüssel wird zum aktuellen und automatisch ein neuer nächster Schlüssel erzeugt.',
                            next: 'Signierschlüssel {{keyId}} wirklich widerrufen? Ein Ersatz für den nächsten Schlüssel wird automatisch erzeugt.',
                            previous:
                                'Signierschlüssel {{keyId}} wirklich widerrufen? Widerrufene Schlüssel bleiben sichtbar, können aber nicht mehr verwendet werden.',
                        },
                        rotateConfirm: {
                            title: 'Signierschlüssel rotieren',
                            message:
                                'Der nächste Signierschlüssel wird zum aktuellen und ein neuer nächster Schlüssel erzeugt.',
                        },
                        rotateAndRevokeConfirm: {
                            title: 'Signierschlüssel rotieren und widerrufen',
                            message:
                                'Der nächste Signierschlüssel wird zum aktuellen, ein neuer nächster erzeugt und der ausgelagerte Schlüssel widerrufen.',
                        },
                    },
                },
                communication: {
                    title: 'Kommunikation',
                    emailSender: {
                        title: 'E-Mail-Absender',
                        description: 'Lege fest, wie E-Mails dieses Mandanten angezeigt werden.',
                        senderName: 'Absendername',
                        senderAddressPrefix: 'Absenderadress-Präfix',
                        replyToAddress: 'Antwortadresse',
                    },
                    emailDomain: {
                        title: 'Eigene Versanddomain',
                        description: 'Versenden Sie E-Mails über eine Domain, die Sie kontrollieren.',
                        domain: 'Domain',
                        setupDescription:
                            'Konfigurieren Sie eine eigene Domain für den E-Mail-Versand. Pro Mandant ist eine eigene Versanddomain möglich.',
                        stateDescription: {
                            pending:
                                'Schließen Sie die folgenden Einrichtungsschritte ab, um E-Mails über diese Domain zu versenden.',
                            done: 'Alle Einrichtungsschritte sind abgeschlossen. Ihre eigene Versanddomain ist aktiv.',
                        },
                        setupProgress: {
                            dns: {
                                title: 'DNS-Verifizierung',
                                description: 'Fügen Sie die folgenden DNS-Einträge bei Ihrem DNS-Anbieter hinzu.',
                            },
                            webhooks: {
                                title: 'Zustellstatus-Updates',
                                description: 'Authy richtet Zustell- und permanente Fehler-Updates ein.',
                            },
                            error: {
                                occurredAt: 'Zuletzt fehlgeschlagen {{date}}',
                            },
                        },
                        lastCheckedAt: 'Letzte Einrichtungsprüfung: {{date}}.',
                        actions: {
                            setup: 'Domain einrichten',
                            refresh: 'Einrichtung aktualisieren',
                            remove: 'Domain entfernen',
                        },
                        removeConfirm: {
                            title: 'Eigene Versanddomain entfernen',
                            message: 'Diese Domain entfernen? E-Mails werden danach über die Standarddomain versendet.',
                        },
                    },
                    emailTemplates: {
                        title: 'E-Mail-Vorlagen',
                        description:
                            'Passen Sie Betreff, Posteingangs-Vorschau und Layout für jede E-Mail an, die Authy im Namen dieses Mandanten sendet.',
                        items: {
                            accountActivation: {
                                title: 'Kontoaktivierung',
                                description:
                                    'Wird gesendet, wenn eine Identität über die API mit einem temporären Passwort erstellt wird.',
                            },
                            emailVerification: {
                                title: 'E-Mail-Bestätigung',
                                description: 'Wird gesendet, wenn jemand seine E-Mail-Adresse bestätigen muss.',
                            },
                            passwordReset: {
                                title: 'Passwort zurücksetzen',
                                description: 'Wird gesendet, wenn jemand sein Passwort zurücksetzen möchte.',
                            },
                            mfaEmailCode: {
                                title: 'Bestätigungscode',
                                description:
                                    'Wird gesendet, wenn bei der Anmeldung ein Einmalcode per E-Mail genutzt wird.',
                            },
                        },
                        fields: {
                            subject: 'Betreff',
                            previewText: 'Vorschautext',
                            previewTextInfo: 'Wird in unterstützten Posteingängen als Vorschau angezeigt.',
                        },
                        emptySubject: 'Kein Betreff',
                        emptyPreviewText: 'Kein Vorschautext',
                        previewError: 'Vorschau konnte nicht geladen werden.',
                        previewEmpty: 'Keine Vorschau verfügbar.',
                        actions: {
                            edit: 'Vorlage bearbeiten',
                            sendTest: 'Test senden',
                        },
                        dialog: {
                            title: '{{template}} bearbeiten',
                            unsavedChanges: {
                                title: 'Ungespeicherte Änderungen verwerfen?',
                                message:
                                    'Beim Wechseln der Sprache werden die Änderungen für die aktuelle Sprache verworfen.',
                            },
                        },
                        sendTest: {
                            title: 'Test-E-Mail senden',
                            recipientEmail: 'Empf\u00e4nger-E-Mail-Adresse',
                            action: 'Test-E-Mail senden',
                            success: 'Test-E-Mail an {{email}} gesendet',
                        },
                    },
                },
            },
            developer: {
                title: 'Entwicklung',
                apiDocumentation: {
                    title: 'API-Dokumentation',
                    description:
                        'Nutzen Sie die Anleitungen für den Einstieg in die API inklusive Authentifizierung; in der API-Referenz finden Sie alle REST-Endpunkte.',
                    tenantId: 'Ihre Mandanten-ID: {{tenantId}}',
                    linkReference: 'Referenz anzeigen',
                },
                navigation: {
                    apiKeys: 'API-Schlüssel',
                    apiLogs: 'API-Protokolle',
                    failureLogs: 'Fehlerprotokolle',
                },
                apiKeys: {
                    title: 'API-Schlüssel verwalten',
                    toolbar: {
                        title: 'API-Schlüssel',
                        counter_zero: 'Keine API-Schlüssel',
                        counter_one: '1 API-Schlüssel',
                        counter_other: '{{count, number}} API-Schlüssel',
                        search: 'API-Schlüssel suchen',
                        newApiKey: 'API-Schlüssel erstellen',
                    },
                    empty: {
                        title: 'Keine API-Schlüssel',
                        subtitle:
                            'Sie haben noch keine API-Schlüssel. Erstellen Sie einen, um die REST-API mit unterschiedlichen Scopes zu nutzen.',
                        actionCreate: 'API-Schlüssel erstellen',
                    },
                    description: 'Mit API-Schlüsseln greifen Sie mit unterschiedlichen Scopes auf die REST-API zu',
                    apiKey: {
                        name: 'Name',
                        apiKey: 'API-Schlüssel',
                        lastSeenAt: 'Zuletzt verwendet',
                        lastSeenAtNever: 'Nie',
                    },
                    create: 'API-Schlüssel erstellen',
                    delete: {
                        title: 'API-Schlüssel löschen',
                        message:
                            'Möchten Sie den API-Schlüssel „{{apiKeyIdentificator}}“ wirklich dauerhaft löschen? Dies kann nicht rückgängig gemacht werden!',
                    },
                    createEditApiKey: {
                        create: {
                            title: 'Neuen API-Schlüssel erstellen',
                            createApiKey: 'API-Schlüssel erstellen',
                        },
                        edit: {
                            title: 'API-Schlüssel bearbeiten',
                        },
                        description: 'Beschreibung',
                        language: 'Sprache',
                    },
                    showApiKey: {
                        title: 'API-Schlüssel erstellt',
                        message:
                            'Bitte kopieren und sichern Sie diesen API-Schlüssel – er wird nicht erneut angezeigt.',
                    },
                },
                failureLogs: {
                    title: 'Fehlerprotokolle',
                    toolbar: {
                        counter_zero: 'Keine Fehler',
                        counter_one: 'Ein Fehler',
                        counter_other: '{{count, number}} Fehler',
                        search: 'Nach Tracking-ID, Details oder IP-Adresse suchen',
                        refresh: 'Aktualisieren',
                        allKinds: 'Alle Typen',
                        allCodes: 'Alle Codes',
                    },
                    kinds: { app: 'Anwendung', protocol: 'Protokoll' },
                    filter: { toCreatedAt: 'Bis' },
                    fields: {
                        createdAt: 'Zeitpunkt',
                        trackId: 'Tracking-ID',
                        kind: 'Typ',
                        code: 'Fehlercode',
                        scope: 'Kontext',
                        ipAddress: 'IP-Adresse',
                        method: 'HTTP-Methode',
                        details: 'Diagnosedetails',
                        sentryEventId: 'Sentry-Ereignis-ID',
                    },
                    empty: {
                        title: 'Keine Fehlerprotokolle gefunden',
                        subtitle:
                            'Es gibt keine aufgezeichneten Fehler, die Ihrer Suche und Ihren Filtern entsprechen.',
                    },
                    details: { title: 'Fehlerdetails', none: 'Wählen Sie einen Fehler aus, um Details anzuzeigen' },
                },
                apiLogs: {
                    title: 'API-Protokolle verwalten',
                    toolbar: {
                        title: 'API-Protokolle',
                        counter_zero: 'Keine API-Protokolle',
                        counter_one: '1 API-Protokoll',
                        counter_other: '{{count, number}} API-Protokolle',
                        search: 'API-Protokolle durchsuchen',
                        refresh: 'Aktualisieren',
                        status: {
                            label: 'Status',
                            all: 'Alle Status',
                            success: 'Erfolg',
                            error: 'Fehler',
                        },
                        method: {
                            label: 'Methode',
                            all: 'Alle Methoden',
                        },
                    },
                    filter: {
                        fromRequestedAt: 'Angefragt am',
                    },
                    empty: {
                        title: 'Keine API-Protokolle',
                        subtitle: 'Sehen Sie, welche API-Aufrufe stattfinden, und behalten Sie die Antworten im Blick.',
                    },
                    description:
                        'In den API-Protokollen sehen Sie, welche API-Aufrufe stattfinden, und können die Antworten nachvollziehen.',
                    apiLog: {
                        method: 'Methode',
                        requestUrl: 'Anfrage-URL',
                        apiKey: 'API-Schlüssel',
                        requestedAt: 'Angefragt am',
                        duration: 'Dauer',
                        responseStatusCode: 'Antwortcode',
                        durations: {
                            millisecondShort: '{{value}} ms',
                            secondShort: '{{value}} s',
                            minuteShort: '{{value}} min',
                            hourShort: '{{value}} h',
                        },
                    },
                    details: {
                        title: {
                            title: 'Details zum API-Protokoll',
                            none: 'Wählen Sie ein API-Protokoll für weitere Details',
                        },
                        info: {
                            requestUrl: 'Anfrage-URL',
                            ipAddress: 'IP-Adresse',
                            finishedAt: 'Beendet am',
                            requestPayload: 'Anfrage',
                            responsePayload: 'Antwort',
                            apiKey: 'API-Schlüssel',
                            requestedAt: 'Angefragt am',
                            duration: 'Dauer',
                            procedure: 'Vorgang',
                            responseStatusCode: 'Antwortcode',
                        },
                    },
                },
            },
        },
        user: {
            profile: {
                title: 'Profil',
                personal: {
                    title: 'Persönliche Angaben',
                    description: 'Diese Informationen sind für andere Administratoren in Ihrem Mandanten sichtbar',
                    avatar: 'Avatar',
                    avatarInfo: 'JPG, GIF oder PNG, maximal 1 MB.',
                    name: 'Ihr vollständiger Name',
                    email: 'Ihre E-Mail-Adresse',
                    changeEmail: 'E-Mail ändern',
                    language: 'Ihre bevorzugte Sprache',
                    bio: 'Ein paar Worte über Sie',
                },
                emailChangeDialog: {
                    title: 'E-Mail-Adresse ändern',
                    email: 'Neue E-Mail-Adresse',
                    save: 'Speichern',
                },
                security: {
                    title: 'Sicherheit',
                    description: 'Passwort ändern und Mehrfaktor-Authentifizierung konfigurieren',
                    securitySettings: 'Sicherheitseinstellungen öffnen',
                },
                'ui-preferences': {
                    title: 'Oberfläche',
                    description:
                        'Legen Sie Darstellungsoptionen fest, die nur für diese Sitzung gelten und andere Instanzen der App nicht beeinflussen.',
                    colorScheme: 'Bevorzugtes Farbschema',
                    colorSchemeValue: {
                        system: 'Systemeinstellung verwenden',
                        light: 'Helles Farbschema',
                        dark: 'Dunkles Farbschema',
                    },
                },
            },
        },
        components: {
            customDomainSetupProgress: {
                dns: {
                    title: 'DNS-Einträge',
                    description:
                        'Fügen Sie die erforderlichen Einträge hinzu, um die Kontrolle über diese Domain zu bestätigen.',
                },
                certificate: {
                    title: 'Zertifikat',
                    description: 'Authy erstellt ein TLS-Zertifikat, sobald die DNS-Einträge verifiziert sind.',
                },
                routing: {
                    title: 'Routing',
                    description: 'Authy erstellt die Routing-Konfiguration, sobald das Zertifikat bereit ist.',
                },
                error: {
                    occurredAt: 'Aufgetreten am {{date}}.',
                },

                lastCheckedAt: 'Letzte Verifizierungsprüfung: {{date}}.',
            },
            durationInput: {
                duration: 'Dauer',
                format: 'Format',
                segmentLabel: '{{label}}: {{unit}}',
                units: {
                    days: 'T',
                    hours: 'h',
                    minutes: 'min',
                    seconds: 's',
                },
            },
            urlListEditor: {
                add: 'URL hinzufügen',
                remove: 'URL entfernen',
                invalidUrl: 'Ungültige URL',
            },
            presenter: {
                presenterType: {
                    title: 'Authentifizierungserlebnis',
                    description: 'Wählen Sie, wie die Authentifizierungsseiten dargestellt werden.',
                    content: {
                        inherit: {
                            title: 'Die Mandanteneinstellungen sind aktiv.',
                            description:
                                'Diese Anwendung übernimmt das Authentifizierungserlebnis sowie die Theme- und Design-Einstellungen des Mandanten.',
                        },
                        static: {
                            title: 'Statische Seiten sind aktiv.',
                            description:
                                'Die Authentifizierung wird mit einfachen servergerenderten Seiten und festem Stil angezeigt.',
                        },
                        spa: {
                            title: 'Die interaktive App ist aktiv.',
                            description:
                                'Die Authentifizierung wird in einer dynamischen App mit anpassbaren Theme- und Design-Optionen angezeigt.',
                        },
                    },
                    actions: {
                        change: 'Erlebnis ändern',
                    },
                    dialog: {
                        title: 'Authentifizierungserlebnis ändern',
                        action: 'Erlebnis ändern',
                        warning: {
                            restoreInheritance:
                                'Eigene Darstellungseinstellungen werden entfernt. Diese Anwendung verwendet anschließend die Mandanteneinstellungen.',
                            inheritToStatic:
                                'Diese Anwendung verwendet statische Authentifizierungsseiten. Die Mandanteneinstellungen bleiben unverändert.',
                            spaToStatic: 'Theme- und Design-Einstellungen werden entfernt.',
                            staticToSpa:
                                'Eine neue interaktive App wird mit Standard-Theme und Standard-Design erstellt.',
                        },
                    },
                },
                spaTheme: {
                    title: 'Theme',
                    description:
                        'Konfigurieren Sie Logos, Farben, das Favicon und helle sowie dunkle Varianten für die interaktive App.',
                    favicon: 'Favicon',
                    faviconInfo: 'Ohne eigenes Favicon wird das Profilbild des Mandanten verwendet.',
                    allowDarkTheme: 'Dunkles Theme erlauben',
                    darkThemeInfo: 'Wenn aktiviert, wird die Systemeinstellung der jeweiligen Person verwendet.',
                    schemes: {
                        light: 'Helles Theme',
                        dark: 'Dunkles Theme',
                    },
                    colors: {
                        accent: 'Akzentfarbe',
                        pageBackground: 'Seitenhintergrund',
                        surfaceBackground: 'Flächenhintergrund',
                    },
                },
                spaDesign: {
                    title: 'Design',
                    description:
                        'Wählen Sie das Layout der Authentifizierungs-App und konfigurieren Sie designspezifische Inhalte.',
                    design: 'Design',
                    splitImage: 'Seitliches Bild',
                    designs: {
                        default: {
                            label: 'Standard',
                            description: 'Separate Anmelde- und Registrierungsseiten im Standardlayout.',
                        },
                        combined: {
                            label: 'Kombiniert',
                            description:
                                'Ein gemeinsamer Begrüßungsbildschirm, auf dem Benutzer Anmeldung oder Registrierung wählen.',
                        },
                        split: {
                            label: 'Geteilt',
                            description: 'Anmelde- und Registrierungsformulare neben einem großen Bildbereich.',
                        },
                    },
                },
                combinedStartPage: {
                    infoTitle: 'Infotitel',
                    infoItems: 'Infoelemente',
                    infoItemPlaceholder: 'Element eingeben',
                    addInfoItem: 'Element hinzufügen',
                    removeInfoItem: 'Element entfernen',
                },
                presenter: {
                    inherit: {
                        label: 'Mandanteneinstellungen verwenden',
                        description: 'Das für den Mandanten konfigurierte Authentifizierungserlebnis übernehmen.',
                    },
                    static: {
                        label: 'Statische Seiten',
                        description: 'Einfache servergerenderte Authentifizierungsseiten mit festem Stil.',
                    },
                    spa: {
                        label: 'Interaktive App',
                        description:
                            'Dynamische Authentifizierungsseiten mit Mandantenlogos, Farben und Design-Optionen.',
                    },
                },
            },
            domainDnsRecordCard: {
                name: 'Name',
                value: 'Wert',
                verified: 'Bestätigt',
                pending: 'Ausstehend',
            },
            tenantPermissionsEditor: {
                searchPlaceholder: 'Tippen, um Berechtigungen zu suchen …',
                noScopeFound: 'Kein Scope gefunden.',
                noAccess: 'Kein Zugriff',
                fullAccess: 'Voller Zugriff',
                partialAccess: 'Teilzugriff',
            },
            tenantRestrictionsEditor: {
                add: '„{{scope}}“-ID eingeben, um eine neue Einschränkung hinzuzufügen …',
                errors: {
                    alreadyExists: 'Bereits vorhanden',
                    invalidId: 'Ungültige ID',
                },
            },
            customRestrictionsEditor: {
                membershipSections: {
                    label: 'Mitglieder nach Mitgliedschaftsbereichen',
                    allowEmpty: 'Zugriff auf Mitglieder ohne Bereiche erlauben',
                    enabled: 'Aktiviert',
                    disabled: 'Deaktiviert',
                    hint: {
                        disabled:
                            'Die Einschränkung ist nicht aktiv. Der Administrator kann auf alle Mitglieder zugreifen, unabhängig von den Bereichen.',
                        noneSelected: 'Es wurden keine Bereiche ausgewählt. Auf kein Mitglied kann zugegriffen werden.',
                        noneSelectedAllowEmpty:
                            'Es wurden keine Bereiche ausgewählt. Nur auf Mitglieder ohne Bereiche kann zugegriffen werden.',
                        selected: 'Nur Mitglieder mit den ausgewählten Bereichen sind zugänglich.',
                        selectedAllowEmpty:
                            'Nur Mitglieder mit den ausgewählten Bereichen oder ohne zugewiesene Bereiche sind zugänglich.',
                    },
                    noAccess:
                        'Der Administrator benötigt mindestens die Berechtigungen zum Lesen von Mitgliedern und deren Bereichen, damit diese Einschränkungen gelten.',
                },
            },
        },
    },
}
